import * as React from 'react';
import styled, { css } from 'styled-components';
import { themeGet } from '@styled-system/theme-get';
import { space } from 'styled-system';

const SVG = (props) => {
  // Configuration du grid (4 colonnes × 3 lignes)
  const cols = 4;
  const rows = 3;

  // Zones où les points doivent apparaître
  const startX = 8;
  const endX = 24;
  const startY = 18;
  const endY = 25;

  const gapX = (endX - startX) / (cols - 1);
  const gapY = (endY - startY) / (rows - 1);

  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      {/* Cadre */}
      <rect
        x="3"
        y="7"
        width="26"
        height="22"
        rx="3"
        fill="transparent"
        stroke="#2C3E50"
        strokeWidth="2"
      />

      {/* Bandeau vert */}
      <path
        d="M4 14 H28 V11 C28 9.895 27.105 9 26 9 H6 C4.895 9 4 9.895 4 11 V14 Z"
        fill="#D5FF4F"
      />

      {/* Anneaux */}
      <rect x="9" y="3" width="2.5" height="6" rx="1.25" fill="#2C3E50" />
      <rect x="20.5" y="3" width="2.5" height="6" rx="1.25" fill="#2C3E50" />

      {/* Grille 4×3 */}
      {Array.from({ length: rows }).map((_, row) =>
        Array.from({ length: cols }).map((_, col) => (
          <circle
            key={`${row}-${col}`}
            cx={startX + col * gapX}
            cy={startY + row * gapY}
            r="1.3"
            fill="#5A6C7D"
          />
        )),
      )}
    </svg>
  );
};

const SIZE = 32;
const CAN_SET_COLOR = false;

const SvgCalendarProposalColor32 = styled(SVG)`
  min-height: ${SIZE}px;
  min-width: ${SIZE}px;
  max-height: ${SIZE}px;
  max-width: ${SIZE}px;
  cursor: ${(p) => (p.$pointer || p.onClick ? 'pointer' : 'default')};
  ${(p) =>
    CAN_SET_COLOR &&
    css`
      path {
        fill: ${themeGet(`colors.${p.color}`, p.color)};
      }
    `}
  ${space}
`;

export default SvgCalendarProposalColor32;
